import { useDropzone } from 'react-dropzone';

const AddFileInput = ({ onFileAccepted }) => {
  const {
    getRootProps,
    getInputProps,
    isDragActive
  } = useDropzone({
    onDrop: acceptedFiles => {
      console.log('Dropped files:', acceptedFiles);
      if (acceptedFiles.length > 0) {
        onFileAccepted(acceptedFiles[0]);
      }
    }
  });

  return (
    <div
      {...getRootProps()}
      className="p-4  rounded text-center"
      style={{
        zIndex: 100000,
        minHeight: 150,
      
        backgroundColor: isDragActive ? '#f0fff0' : 'white',
        cursor: isDragActive ? 'copy' : 'pointer',
        transition: 'all 0.2s ease-in-out',
      }}
    >
      <input {...getInputProps()} />
      <p>{isDragActive ? "Drop the file here..." : "Drag & drop a file here, or click to select"}</p>
    </div>
  );
};

export default AddFileInput;
